
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 2.749a.75.75 0 011.266-.544l4.5 4.25a.745.745 0 010 1.088l-4.5 4.25A.75.75 0 0113 11.249v-2.25h-1.453A2.547 2.547 0 009 11.546c0 .697.322 1.072.6 1.265.213.147.4.375.4.635 0 .306-.25.556-.556.556h-.078a.55.55 0 01-.222-.044C8.588 13.711 6 12.418 6 9.5c0-2.484 2.016-4.5 4.5-4.5H13v-2.25zM1 6.499a2.5 2.5 0 012.5-2.5H4a.999.999 0 110 2h-.5c-.275 0-.5.225-.5.5v9c0 .275.225.5.5.5h9c.275 0 .5-.225.5-.5v-.5a.999.999 0 112 0v.5a2.5 2.5 0 01-2.5 2.5h-9a2.5 2.5 0 01-2.5-2.5v-9z","fill":"#B4BCCF"}})])
          )
        }
      }
    